<template>
  <div class="fixed">
    <div id="navbar">
      <div class="logos">
        <div class="logo l">
          <router-link to="/goodlist" tag="a">
            <img src="../../public/img/Icon5.png" alt="logo" />
          </router-link>
        </div>
        <nav class="l navbar">
          <ul>
            <!-- <li class="l">
              <router-link to="/home" tag="li" active-class="kerwinactive">
                <span class="others">Home</span>
              </router-link>
            </li> -->
            <!-- <li class="l">
              <router-link to tag="li">
                <span class="wholesales others">
                  Wholesales
                  <ul class="produ">
                    <li @click="handlePro()">
                      <p class="produ_1 first" style="margin-bottom:0;">Products</p>
                    </li>
                    <li class="produ_1">Promotions</li>
                  </ul>
                </span>
              </router-link>
            </li> -->
            <li class="l">
              <router-link to="/goodlist" tag="li" active-class="kerwinactive">
                <span class="others">Products</span>
              </router-link>
            </li>
            <li class="l">
              <router-link to="/introduction" tag="li" active-class="kerwinactive">
                <span class="others">Our Brands</span>
              </router-link>
            </li>
            <li class="l" @click="handleMyorder()">
              <!-- <router-link to="/myorder" tag="li" active-class="kerwinactive"> -->

              <span class="others">My Order</span>
              <!-- </router-link> -->
            </li>
            <li class="l">
              <router-link to="/aboutus" tag="li" active-class="kerwinactive">
                <span class="others">About Us</span>
              </router-link>
            </li>
          </ul>
        </nav>
        <div class="l attr-nav">
          <ul>
            <input
              type="text"
              class="searchs search"
              placeholder="Search..."
              v-model="$store.state.value"
              @keyup.enter="handlesearchclick()"
            />
            <li class="l icons-list" @click="handlesearchclick()">
              <a-icon type="search" />
            </li>
            <li class="l icons-list show">
              <a-icon type="setting" />
              <div>
                <!-- <router-link to="/address" tag="li" active-class="kerwinactive"> -->
                <li @click="handleAddress()">
                  <p>Shipping Address</p>
                </li>
                <!-- </router-link> -->
                <!-- <router-link to="/security" tag="li" active-class="kerwinactive"> -->
                <li @click="handleSecurity()">
                  <p>Account Security</p>
                </li>
                <!-- </router-link> -->
              </div>
            </li>
            <!-- <router-link to="/shoppingcart" tag="span" active-class="kerwinactive"> -->
            <span @click="handleShopping()">
              <li class="l icons-list number">
                <a-icon type="shopping-cart" />
                <div class="cartNumber">
                  <a-badge :count="$store.state.count" />
                </div>
              </li>
            </span>
            <!-- </router-link> -->
            <li class="l icons-list">
              <span
                :style="{'display':$store.state.code == '1' || $store.state.code == null ? 'block':'none'}"
              >
                <router-link to="/login" tag="li" active-class="kerwinactive">
                  <a-icon type="user" />
                </router-link>
              </span>
              <span
                :style="{'display':$store.state.code == '' ? 'block':'none'}"
                @click="handleDelete()"
              >
                <a-icon type="logout" />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      // value:''
    }
  },
  methods: {
    handlePro () {
      this.$store.state.brandsId = false
      sessionStorage.removeItem('brandsId')
      sessionStorage.removeItem('typeId')
      sessionStorage.removeItem('goodsName')
      sessionStorage.setItem('goodsCode', 0)
      this.$router.push('/goodlist')
    },
    handleMyorder () {
      if (this.$store.state.code == 1) {
        swal('Login information not found', {
          button: false,
          timer: 3000
        })
        this.$router.push('/login')
      } else {
        this.$router.push('/myorder')
      }
    },
    handleAddress () {
      if (this.$store.state.code == 1) {
        swal('Login information not found', {
          button: false,
          timer: 3000
        })
        this.$router.push('/login')
      } else {
        this.$router.push('/address')
      }
    },
    handleSecurity () {
      if (this.$store.state.code == 1) {
        swal('Login information not found', {
          button: false,
          timer: 3000
        })
        this.$router.push('/login')
      } else {
        this.$router.push('/security')
      }
    },
    handleShopping () {
      if (this.$store.state.code == 1) {
        swal('Login information not found', {
          button: false,
          timer: 3000
        })
        this.$router.push('/login')
      } else {
        this.$router.push('/shoppingcart')
      }
    },
    handlesearchclick () {
      // setTimeout(() => {
      //   this.value = ''
      // }, 1000)
      this.$store.state.brandsId = false
      sessionStorage.setItem('goodsName', this.$store.state.value)
      sessionStorage.setItem('goodsCode', 2)
      sessionStorage.removeItem('brandsId')
      sessionStorage.removeItem('typeId')
      this.$store.dispatch('getGoodslistAction', {
        typeId: sessionStorage.getItem('typeId'),
        goodsBrands: sessionStorage.getItem('brandsId'),
        goodsName: sessionStorage.getItem('goodsName')
      })

      if (this.$router.history.current.path == '/goodlist') {
      } else {
        this.$router.push('/goodlist')
      }
    },
    handleDelete () {
      localStorage.removeItem('token', 'code')
      localStorage.setItem('code', 1)
      // this.$router.push('/home')
      location.href = `http://www.awesomewholesale.com.au`
      // location.href = '/home'
    }
  },
  beforeCreate () {
    this.$store.state.code = localStorage.getItem('code')
  }
}
</script>
<style>
.ant-badge-count {
  min-width: 0 !important;
  width: 16px !important;
  height: 13px !important;
  line-height: 14px !important;
  padding: 0 !important;
}
</style>
<style lang="scss" scoped>
.fixed {
  height: 1rem;
  @media screen and (max-width: 768px) {
    height: 2rem;
  /* 在屏幕宽度小于等于768px时应用的样式 */

  }

}
#navbar {
  background: #013040;
  background-color: #001d47;
  height: 1rem;
  position: fixed;
  z-index: 6;
  width: 100%;
  @media screen and (max-width: 768px) {
    height: 2rem;
  /* 在屏幕宽度小于等于768px时应用的样式 */

  }
  .logos {
    height: 100%;
    position: relative;
    .logo {
      width: 2.5rem;
      margin-top: 0.05rem;
      margin-left: 0.625rem;
      a {
        display: block;
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
    .navbar {
      ul {
        margin-left: 0.75rem;
        height: 100%;
        li {
          color: #fff;
          span.others {
            user-select: none; //不能被选中文字
            cursor: pointer;
            font-weight: 500;
            width: 1.45rem;
            height: 1rem;
            display: block;
            text-align: center;
            line-height: 1rem;
            box-sizing: border-box;
            &.wholesales:hover {
              border-bottom: none;
            }
            &:hover {
              font-size: 0.25rem;
              .produ {
                top: 1rem;
                z-index: 8;
                opacity: 0.8;
              }
            }
          }
        }
      }
    }
    .wholesales {
      position: relative;
      .produ {
        transition: all 0.5s;
        position: absolute;
        top: -0.2rem;
        left: -0.8rem;
        z-index: -30;
        box-shadow: 3px 3px 0.125rem #013040;
        opacity: 0;
        .produ_1 {
          width: 1.5rem;
          line-height: 0.51rem;
          background: #013040;
          box-sizing: border-box;
          &:hover {
            opacity: 0.9;
          }
        }
      }
    }
    .attr-nav {
      height: 100%;
      margin-left: 4.5rem;
      ul {
        position: relative;
        height: 100%;
        .search {
          position: absolute;
          top: 0.25rem;
          right: 2.625rem;
          width: 1.25rem;
          height: 0.5rem;
          outline: none;
          border: none;
          border-radius: 0.25rem;
          padding-left: 0.125rem;
          transition: all 0.5s;
          &::placeholder {
            color: #fff;
          }
          background: transparent;
          // opacity: .5;
        }
        .searchs {
          width: 4.375rem;
          background: #fff;
          &::placeholder {
            color: #ccc;
          }
        }
        li {
          width: 0.68rem;

          line-height: 1rem;
          text-align: center;
          font-size: 0.25rem;
          cursor: pointer;
          color: white;
          &:hover {
            font-size: 0.26rem;
          }
        }
        li.number {
          position: relative;
          .cartNumber {
            position: absolute;
            top: -0.1875rem;
            left: 0.375rem;
          }
        }
        li.show {
          position: relative;
          &:hover {
            div {
              top: 1rem;
              opacity: 1;
            }
          }
          div {
            position: absolute;
            top: -1px;
            left: -0.825rem;
            transition: all 0.5s;
            z-index: -1;
            opacity: 0;
            p {
              width: 2.5rem;
              margin-bottom: 0;
              line-height: 0.5rem;
              background: #013040;
              opacity: 0.9;
              &:hover {
                opacity: 0.8;
              }
            }
          }
        }
      }
    }
  }
}
</style>
